import styled from 'styled-components';

import {
  colors,
  FONT_FAMILIES,
} from '../../../../common/styles/style-constants';

export const Button = styled.button`
  appearance: none;
  display: flex;
  align-items: center;
  color: ${colors.gray7};
  font-family: ${FONT_FAMILIES.circular};
  background: none;
  border: none;
  padding: 0;
  font-size: 14px;
  cursor: pointer;
  transition: color 0.2s ease-in-out;
  margin: ${(props) => props.margin || '0'};

  &:hover,
  &:focus {
    color: ${colors.gray9};
  }

  & > .anticon {
    padding-right: 3px;
  }
`;
